import { render, staticRenderFns } from "./DragPointer.vue?vue&type=template&id=543d9e3e&"
import script from "./DragPointer.vue?vue&type=script&lang=js&"
export * from "./DragPointer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543d9e3e')) {
      api.createRecord('543d9e3e', component.options)
    } else {
      api.reload('543d9e3e', component.options)
    }
    module.hot.accept("./DragPointer.vue?vue&type=template&id=543d9e3e&", function () {
      api.rerender('543d9e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/Table/DragPointer.vue"
export default component.exports